module.exports = __webpack_public_path__ + "img/DSC_1885.9e00e08c.JPG";